import styled from 'styled-components';

export const SDealerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(max(100px, calc(25% - 16px)), 100%), 1fr));
  column-gap: 16px;
  row-gap: 8px;
`;
